import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { TRAITS, USER_ID } from 'actions/Base';

export const INITIAL_STATE = {
  isLoading: false,
};

export const onGetCharacteristicGiversRequest = (state) => ({ ...state, isLoading: true });
export const onGetCharacteristicGiversFailure = (state) => ({ ...state, isLoading: false });
export const onGetCharacteristicGiversSuccess = (state, { payload }) => {
  state.isLoading = false

  if(payload.data.pageable.pageNumber === 0) {
    return _.set(USER_ID({ userType: payload.userType, id: payload.studentId }), payload.data)(state);
  }
  else {
    let current = _.cloneDeep(_.get(USER_ID({ userType: payload.userType, id: payload.studentId }))(state) || {});
    const contentArray = [ ...current.content, ...payload.data.content ]
    current = payload.data
    current.content = contentArray
    return _.set(USER_ID({ userType: payload.userType, id: payload.studentId }), current)(state);
  }
};

export const ACTION_HANDLERS = {
  [TRAITS.GET_CHARACTERISTIC_GIVERS_REQUEST]: onGetCharacteristicGiversRequest,
  [TRAITS.GET_CHARACTERISTIC_GIVERS_FAILURE]: onGetCharacteristicGiversFailure,
  [TRAITS.GET_CHARACTERISTIC_GIVERS_SUCCESS]: onGetCharacteristicGiversSuccess
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
